import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function SignIn() {
  const { signIn, oauthSignIn, config } = useAuth();
  const showOauth = config?.enableGoogleIdp || config?.enableAppleIdp;
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault(); setErr(null);
    try { await signIn(email, password); nav('/map'); }
    catch (e: any) { setErr(e.message); }
  }

  return (
    <div className="container" style={{ maxWidth: 460 }}>
      <div className="card">
        <h2>Sign in</h2>
        <form onSubmit={submit}>
          <label>Email</label>
          <input type="email" required value={email} onChange={e => setEmail(e.target.value)} style={{ width: '100%' }} />
          <label style={{ marginTop: 10 }}>Password</label>
          <input type="password" required value={password} onChange={e => setPassword(e.target.value)} style={{ width: '100%' }} />
          {err && <p className="pill bad" style={{ marginTop: 10 }}>{err}</p>}
          <button type="submit" style={{ marginTop: 14 }}>Sign in</button>
        </form>
        {showOauth && (
          <>
            <hr style={{ margin: '18px 0', border: 'none', borderTop: '1px solid var(--line)' }} />
            <div className="row">
              {config?.enableGoogleIdp && (
                <button className="ghost" onClick={() => oauthSignIn('Google')}>Continue with Google</button>
              )}
              {config?.enableAppleIdp && (
                <button className="ghost" onClick={() => oauthSignIn('SignInWithApple')}>Sign in with Apple</button>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
